<template>
    <div class="legend">
        <div v-if="Array.isArray(colorItems) && colorItems.length > 0" class="legend-items">
            <span class="legend-heading" v-if="hasTitle">{{ title }}</span>
            <span class="legend-sub-heading" v-if="hasSubTitle">{{ subTitle }}</span>
            <div v-for="item in colorItems" :key="item.text" class="legend-item">
                <div class="legend-item-color" :style="{ backgroundColor: item.color }"></div>
                <div class="legend-item-text">{{ item.text }}</div>
            </div>
        </div>
    </div>
</template>

<script>

import { ColorClassLegend, ColorClassLegendItem } from '@/lib/Forecast.js'
import logger from '@/lib/logger.js'

export default {
    name: 'MapLegend',
    data() {        
        return {
            colorItems: [],
            title: null,
            subTitle: null
        }
    },
    methods: {
        updateVarItem(varItem) {
            logger.log('Setting variable for display', varItem)
            this.varItem = varItem

            let title = ''
            let colorItems = []

            if (varItem != null) {
              title = varItem.name
              if (varItem.units !== '')
                title = title + ' (' + this.varItem.units + ')'
            }

            for(let i=0; i < varItem.legend.colorClasses.length; i++) {
              const cc = varItem.legend.colorClasses[i]
              colorItems.push(cc)
            }

            this.title = title
            this.subTitle = null
            this.colorItems = colorItems
        },
        updateLegend(title, subTitle, colors) {
          console.log('update legend', title, subTitle, colors)
          this.title = title
          this.subTitle = subTitle
          this.colorItems = colors
        }
    },
    computed: {
        hasTitle() {
          return this.title != null && this.title !== ''
        },
        hasSubTitle() {
          return this.subTitle != null && this.title !== ''
        },
        legendTitle() {
            let title = ''
            
            if (this.varItem != null) {
                title = this.varItem.name
                if (this.varItem.units != '') {
                    title = title + ' (' + this.varItem.units + ')'
                }
            }

            return title
        }
    }
}
</script>

<style>
    .legend-item {
        line-height: 20px;
    }

    .legend-item-color {
        display: inline-block;
        width: 15px;
        height: 15px;
        border: 1px solid black;
    }

    .legend-item-text {
        font-size: 10pt;
        display: inline-block;
        margin-left: 10px;
    }

    .legend-heading {
        display: block; 
        line-height: initial; 
        font-size: 1rem
    }

    .legend-sub-heading {
      display: block;
      line-height: initial;
      font-size: 0.8rem
    }

</style>
